import Vue from 'vue';
// eslint-disable-next-line
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import Vuetify from 'vuetify';
// import axios from 'axios';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';

// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// if (localStorage.getItem('api_token')) {
//   axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('api_token')}`;
// }

Vue.config.productionTip = false;
Vue.use(Vuetify, {
  iconfont: 'fa',
  icons: {
    // eslint-disable-next-line
    'times': 'fas fa-times',
    // eslint-disable-next-line
    'circle-notch': 'fas fa-circle-notch',
    // eslint-disable-next-line
    'chevron-left': 'fas fa-chevron-left',
    // eslint-disable-next-line
    'user': 'fas fa-user',
    // eslint-disable-next-line
    'home': 'fas fa-home',
    // eslint-disable-next-line
    'calendar-alt': 'fas fa-calendar-alt',
    // eslint-disable-next-line
    'list-ul': 'fas fa-list-ul',
    // eslint-disable-next-line
    'dollar-sign': 'fas fa-dollar-sign',
    'sign-out-alt': 'fas fa-sign-out-alt',
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

router.beforeEach((to, from, next) => {
  store.commit('setPreviousRoute', from.path);
  next()
})

